import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './occasionSelector.module.css';
import { getCategoriesDetails } from '../../../services/reservations/reservationsService';
import { WelletContext } from '../../../context/WelletContext';
import { useSelector } from 'react-redux';

const OccasionSelectorButton = ({ handleSelectButton, selectedButton }) => {
  const { t } = useTranslation();
  const [categoriesInfo, setCategoriesInfo] = useState(null);
  const welletContext = useContext(WelletContext);
  const lang = useSelector((state) => state.app.language);
  const getPickupDetails = async () => {
    try {
      const result = await getCategoriesDetails(welletContext, lang);
      setCategoriesInfo(result.data);
    } catch (error) {
      console.error(error);
      setCategoriesInfo(null);
    }
  };
  useEffect(() => {
    getPickupDetails();
  }, []);

  if (!categoriesInfo?.occasions?.length) {
    return null;
  }

  return (
    <>
      <div className='fw-semibold text-primary font-tiny mb-3'>{t('whatOccasion')}</div>

      {categoriesInfo.occasions.map((p) => (
        <button
          key={p.id}
          onClick={() => handleSelectButton(p.id)}
          className={`font-small fade-up ${styles.occasionButton} ${
            selectedButton === p.id ? styles.selected : ''
          }`}
          type='button'
        >
          {p.name}
        </button>
      ))}
    </>
  );
};

export default OccasionSelectorButton;
